import React, { PureComponent } from 'react'
import Input from '../../Form/Input'
import activityTrackingService from '../../../../services/activityTrackingService'
import PropTypes from 'prop-types'
import TextArea from '../../Form/TextArea'

/**
 * TextAreaTracked tracks value changes and triggers a trackEvent,
 * when focus is lost
 */
class TextAreaTracked extends PureComponent {

  onFocusStartValue = ''

  onBlur = () => {
    const { onBlur, eventName, eventOpts, value } = this.props
    const valueChanged = value !== this.onFocusStartValue
    valueChanged && activityTrackingService.trackEvent(eventName, eventOpts)
    onBlur && onBlur()
  }

  onFocus = () => {
    const { onFocus, value } = this.props
    this.onFocusStartValue = value ?? ''
    onFocus && onFocus()
  }

  render () {
    const parentProps = { ...this.props }
    delete parentProps.eventName
    delete parentProps.eventOpts
    return (
      <TextArea {...parentProps} onFocus={this.onFocus} onBlur={this.onBlur}/>
    )
  }
}

TextAreaTracked.defaultProps = TextArea.defaultProps
TextAreaTracked.propTypes = {
  ...Input.propTypes,
  ...TextArea.propTypes,
  eventName: PropTypes.string.isRequired,
  eventOpts: PropTypes.object.isRequired
}
export default TextAreaTracked
